const formatValue = v => {
  if (typeof v === 'string' || typeof v === 'number') {
    return v.toString();
  }
  return '';
};
export function getTransedText(locale, params) {
  if (Array.isArray(params)) {
    params.forEach(v => {
      locale = locale.replace('{}', formatValue(v));
    });
  } else if (typeof params === 'object') {
    Object.keys(params).forEach(k => {
      locale = locale.replace("{".concat(k, "}"), formatValue(params[k]));
      // 匹配单复数格式的参数
      const matchedTexts = locale.match(new RegExp("{".concat(k, ":[a-zA-Z0-9\\s]*/[a-zA-Z0-9\\s]*}"), 'g'));
      if (matchedTexts !== null && matchedTexts !== void 0 && matchedTexts.length) {
        matchedTexts.forEach(text => {
          const [singleText, multipleText] = text.slice(1, -1).split(':')[1].split('/');
          locale = locale.replace(text, params[k] === 1 ? singleText : multipleText);
        });
      }
    });
  }
  return locale;
}